import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';

import { Iconify } from 'src/components/iconify';

import { useAuth, revokeSession } from 'src/auth/auth-context';

// ----------------------------------------------------------------------
// Faixa de VISITA FISCAL: aparece só quando um fiscal está navegando o portal
// LOGADO como o contribuinte (auth /auth/me traz `imp`). Deixa explícito o modo
// e oferece o retorno à Auditoria. Tom âmbar (modo especial), não roxo/azul.
// ----------------------------------------------------------------------

const AMBER = '#B76E00';

function formatDoc(doc: string): string {
  const d = (doc || '').replace(/\D/g, '');
  if (d.length === 14) return d.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  if (d.length === 11) return d.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  return doc;
}

export function ImpersonationBanner() {
  const { user } = useAuth();
  const imp = user?.imp;
  if (!imp) return null;

  const voltar = () => {
    const destino = imp.returnUrl || `${import.meta.env.BASE_URL}login`;
    // Revoga a sessão no servidor (keepalive, sobrevive à navegação) e sai JÁ.
    // NÃO usamos o logout() do contexto de propósito: ele faz setUser(null), que
    // re-renderiza a tela de login do portal por um instante antes do redirect —
    // era esse o flash de ~1s ao "Voltar à Auditoria".
    revokeSession();
    window.location.href = destino;
  };

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar + 1,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1.5,
        px: { xs: 2, md: 3 },
        py: 1,
        color: AMBER,
        bgcolor: alpha(AMBER, 0.14),
        borderBottom: `1px solid ${alpha(AMBER, 0.32)}`,
      }}
    >
      <Iconify icon="solar:eye-bold" width={20} sx={{ flexShrink: 0 }} />
      <Typography variant="body2" sx={{ fontWeight: 600, flexGrow: 1, minWidth: 0 }}>
        Visita Fiscal — você está navegando como o contribuinte{' '}
        <Box component="span" sx={{ fontWeight: 700 }}>
          {formatDoc(user!.usr_login)}
        </Box>
        {imp.actorName ? (
          <Box component="span" sx={{ fontWeight: 400, color: 'text.secondary' }}>
            {' '}
            · fiscal {imp.actorName}
          </Box>
        ) : null}
      </Typography>
      <Button
        size="small"
        variant="contained"
        onClick={voltar}
        startIcon={<Iconify icon="eva:arrow-ios-back-fill" />}
        sx={{ flexShrink: 0, bgcolor: AMBER, color: 'common.white', '&:hover': { bgcolor: '#8A5300' } }}
      >
        Voltar à Auditoria
      </Button>
    </Box>
  );
}
